import { Component, OnInit } from "@angular/core";
import { IAccountFeatureDescription } from "@app/services/accountFeature.service";
import { NavigationService } from "@app/services/navigation.service";
import { Observable } from "rxjs";
import { AccountService } from "../../../_services/account.service";
import './customer-overview.component.scss';

@Component({
    selector: 'customer-overview',
    template: require('./customer-overview.component.html')
})
export class CustomerOverviewComponent implements OnInit {

    loading: boolean;
    customerId: number;
    accountFeatureSet$: Observable<IAccountFeatureDescription[]>;

    constructor(
        private readonly accountService: AccountService,
        private readonly navigationService: NavigationService) { }

    ngOnInit(): void {
        this.customerId = this.navigationService.getRouteParam("customerId");
        this.updateFeatureset();
    }

    updateFeatureset(): void {
        this.accountFeatureSet$ = this.accountService.updateFeatureSet(this.customerId);
    }

    //--

}
